module.exports = __webpack_public_path__ + "img/pore_survey_1.1f76466c.png";